import axios from "axios";

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://api.titiksenyapstudio.id/api";

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    Accept: "application/json",
  },
});

export const fetchServices = async (fallbackData = []) => {
  try {
    const res = await apiClient.get("/services");
    if (res.data && res.data.data && res.data.data.length > 0) {
      return res.data.data;
    }
    return fallbackData;
  } catch (err) {
    console.warn("Backend API not reachable, using fallback:", err.message);
    return fallbackData;
  }
};

export const getImageUrl = (url) => {
  if (!url) return "";
  // If it is already an absolute URL (http:// or https://), return as is
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }
  // If it is an uploaded file from Filament / Laravel storage (e.g. "portfolios/xxx.jpg" or "/storage/xxx")
  if (url.startsWith("/storage/") || url.startsWith("storage/")) {
    const cleanPath = url.startsWith("/") ? url : `/${url}`;
    return `https://api.titiksenyapstudio.id${cleanPath}`;
  }
  if (url.startsWith("portfolios/") || url.startsWith("services/") || url.startsWith("catalog/")) {
    return `https://api.titiksenyapstudio.id/storage/${url}`;
  }
  // Otherwise, it is a local public asset on frontend (e.g. "/images/portfolio/...")
  return url;
};

export const fetchPortfolios = async (fallbackData = []) => {
  try {
    const res = await apiClient.get("/portfolio");
    if (res.data && res.data.data && res.data.data.length > 0) {
      // Normalize image_url to imageUrl and ensure absolute URL if needed
      return res.data.data.map((item) => ({
        ...item,
        imageUrl: getImageUrl(item.image_url || item.imageUrl),
      }));
    }
    return fallbackData;
  } catch (err) {
    console.warn("Backend API not reachable, using fallback:", err.message);
    return fallbackData;
  }
};

export const fetchCatalog = async (fallbackData = []) => {
  try {
    const res = await apiClient.get("/catalog");
    if (res.data && res.data.data && res.data.data.length > 0) {
      return res.data.data.map((item) => ({
        ...item,
        imageUrl: getImageUrl(item.image_url || item.imageUrl),
      }));
    }
    return fallbackData;
  } catch (err) {
    console.warn("Backend API not reachable, using fallback:", err.message);
    return fallbackData;
  }
};
